import { LeftOutlined, ShareAltOutlined } from '@ant-design/icons';
import { Button, Col, Divider, Modal, notification, Row, Spin } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import offerAPI from '~/api/OfferAPI';
import userAPI from '~/api/UserAPI';
import RefillNowModal from '~/components/FormRefillNow';
// import Wallet from '~/components/Wallet';
import config from '~/config';
// import CardAboutMe from '../../components/card-about-me';
import React from 'react';
import classNames from 'classnames/bind';
import styles from './TopUpDetail.module.scss';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';
import { IMAGES } from '~/assets/assetsPath';
import FormCanNot from '~/components/FormCanNot';
import FormShare from '~/components/FormShare';
import shareAPI from '~/api/Share';
import { useSelector } from 'react-redux';
import { getNumberWithCommas } from '~/utils';
import CancelModal from '~/components/FormCancel';

const cx = classNames.bind(styles);

const TopUpDetail = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const id = useParams();

    const userInfo = useSelector((state) => state.user.userInfo);
    const isLogin = userInfo?.id || '';

    const [showAmount, setShowAmount] = useState(false);
    const [amount, setAmount] = useState(0);
    const [isShowRefillNowModal, setIsShowRefillNowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [wallet, setWallet] = useState(0);
    const [offer, setOffer] = useState({});

    const [isShowCanNotShare, setIsShowCanNotShare] = useState(false);

    const [isShowShare, setIsShowShare] = useState(false);
    const [titleShare, setTitleShare] = useState('');
    const [contentShare, setContentShare] = useState('');
    const [linkShare, setLinkShare] = useState('');

    const [isShowRequireLogin, setIsShowRequireLogin] = useState(false);

    const onAgreeLogin = () => {
        navigate(config.routes.login);
        localStorage.setItem('navigateAfterLogin', location.pathname + location.search);
        setIsShowRequireLogin(false);
    };
    const onRejectLogin = () => {
        setIsShowRequireLogin(false);
    };

    const handleAgreeShare = async () => {
        handleShare();
        onCopy();
        setIsShowShare(false);
    };
    const handleRejectShare = () => {
        setIsShowShare(false);
    };

    const handelShowRefillNowModal = () => {
        if (isLogin) {
            setIsShowRefillNowModal(true);
        } else {
            setIsShowRequireLogin(true);
        }
    };

    const onRejectRefillNow = () => {
        setIsShowRefillNowModal(false);
    };

    const handleShare = () => {
        if (navigator.share) {
            navigator
                .share({
                    title: 'Ahappi - Ecommerce\n',
                    text: offer?.title,
                    url: linkShare,
                })
                .then(() => console.log('Successful share'))
                .catch((error) => console.log('Error sharing', error));
        }
    };

    const onCopy = async () => {
        notification.open({
            message: 'Copy link successfully!',
            duration: 2,
            placement: 'top',
        });
        await navigator.clipboard.writeText(linkShare);
    };

    const handleClickShare = async () => {
        if (isLogin) {
            if (userInfo?.is_collab) {
                try {
                    const res = await shareAPI.createLinkShareAPI({ offer_id: offer?.id });
                    setLinkShare(res?.results?.object?.link);
                } catch (err) {
                    console.log(err);
                }
                setTitleShare(`Share tag ${offer?.title}`);
                setContentShare(
                    `The commission amount you receive when a customer makes a transaction for the first time is: ${getNumberWithCommas(
                        (parseInt(offer?.from) * 10) / 100,
                    )} d
                    <br>
                    The commission amount you receive when a customer makes a transaction the second time is: ${getNumberWithCommas(
                        (parseInt(offer?.from) * 3) / 100,
                    )} d`,
                );
                setIsShowShare(true);
            } else {
                setIsShowCanNotShare(true);
            }
        } else {
            setIsShowRequireLogin(true);
        }
    };

    const onAgreeRefillNow = async () => {
        setIsShowRefillNowModal(false);
        try {
            const params = {
                amount: parseInt(amount),
            };
            if (offer?.sharer_id) {
                params.sharer_id = offer.sharer_id;
            }
            const res = await userAPI.deposit(params);
            if (res.code === 200) {
                setWallet(Math.ceil(parseInt(wallet) + parseInt(amount)));
                notification.open({
                    message: 'You have submitted your deposit request, we will contact you within 24 hours.',
                    duration: 1.5,
                    placement: 'top',
                });
            }
            navigate(config.routes.historyTopUp);
        } catch (err) {
            console.log(err);
        }
    };
    const handleGetOffer = async () => {
        setIsLoading(true);
        try {
            const params = {
                fields: '["$all"]',
            };

            const res = await offerAPI.getOneOfferAPI(id.topUp_id, params);

            if (res.code === 200) {
                const item = res.results.object;
                const search = location?.search?.split('?').join('');
                const sharerId = new URLSearchParams(search)?.get('sharer_id');
                if (sharerId && sharerId !== userInfo?.id) {
                    if (userInfo?.amount_of_buy_card) {
                        item.sale_price = (parseInt(item.from) * 1) / 100;
                    } else {
                        item.sale_price = (parseInt(item.from) * 2) / 100;
                    }
                    item.sharer_id = sharerId;
                } else {
                    if (userInfo?.is_collab) {
                        item.sale_price = (parseInt(item.from) * 5) / 100;
                        item.sharer_id = '';
                    } else {
                        item.sale_price = 0;
                        item.sharer_id = '';
                    }
                }
                setOffer({ ...item });
            }
        } catch (err) {
            console.log(err);
        }
        setIsLoading(false);
    };

    useEffect(() => {
        handleGetOffer();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangThongTinTheNap');
        // eslint-disable-next-line
    }, []);

    const renderExpireDay = (item) => {
        switch (item?.time_type) {
            case 'DAY':
                return `${item?.expired} date`;
            case 'MONTH':
                return `${item?.expired} month`;
            case 'YEAR':
                return `${item?.expired} year`;
            default:
                return;
        }
    };

    return (
        <div className={cx('wrapper')}>
            {isLoading ? (
                <Row justify="center" align="middle" style={{ height: '500px' }}>
                    <Spin />
                </Row>
            ) : (
                <>
                    {offer?.id ? (
                        <div className={cx('container')}>
                            <div className={cx('title_header')}>
                                <Row className={cx('title_header_row')}>
                                    <p className={cx('title')}>
                                        <LeftOutlined onClick={() => navigate(-1)} className={cx('btn_back')} /> Chi
                                        Card purchase details
                                    </p>
                                </Row>
                            </div>
                            <div className={cx('right_section')}>
                                <Row className={cx('name_page')}>
                                    <LeftOutlined
                                        onClick={() => navigate(config.routes.topUp)}
                                        className={cx('btn_back')}
                                    />{' '}
                                    <Col>Card purchase details</Col>
                                </Row>
                                <div className={cx('right_container')}>
                                    <Row justify="center">
                                        <img
                                            src={offer?.image || IMAGES.ImagePlaceholder}
                                            alt="topup-detail"
                                            style={{ width: '60%', height: 'auto' }}
                                        />
                                    </Row>
                                    <div className={cx('right_content')}>
                                        <Row style={{ alignItems: 'center' }}>
                                            <Col xs={14}>
                                                {offer?.sale_price ? (
                                                    <div className={cx('row_text')}>
                                                        {getNumberWithCommas(
                                                            parseInt(offer.from) - parseInt(offer.sale_price),
                                                        ) || 0}
                                                        d&nbsp;
                                                        <span className={cx('price_origin')}>
                                                            {getNumberWithCommas(parseInt(offer.from)) || 0} d
                                                        </span>
                                                    </div>
                                                ) : (
                                                    <div className={cx('row_text')}>
                                                        {getNumberWithCommas(parseInt(offer.from)) || 0} d
                                                    </div>
                                                )}
                                            </Col>
                                            <Col xs={10}>
                                                <Row justify="end">
                                                    <Button
                                                        className={cx('btn_share')}
                                                        onClick={handleClickShare}
                                                        // loading={isLoading}
                                                    >
                                                        Share
                                                        <ShareAltOutlined
                                                            style={{
                                                                fontSize: '20px',
                                                                fontWeight: '600',
                                                                color: '#311d4f',
                                                            }}
                                                        />
                                                    </Button>
                                                </Row>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={12}>
                                                <div className={cx('row_text')}>Offer: {offer?.offer}%</div>
                                            </Col>
                                            <Col xs={12}>
                                                <Row justify="end">
                                                    <div className={cx('row_text')}>
                                                        Expiry date: {renderExpireDay(offer)}
                                                    </div>
                                                </Row>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <div className={cx('row_text')}>
                                                Receive:{' '}
                                                {getNumberWithCommas((parseInt(offer.from) * offer.offer) / 100) || 0} d
                                            </div>
                                        </Row>
                                    </div>
                                    <Divider style={{ borderTop: '5px solid rgba(0,0,0,.06)' }} />
                                    <Row className={cx('title')}>
                                        <Col>Detailed information</Col>
                                    </Row>

                                    <Row className={cx('tutorial_content')}>
                                        <Col>
                                            <div dangerouslySetInnerHTML={{ __html: offer.description }}></div>
                                            {/* <ul>
                                                <li>
                                                    <span style={{ fontWeight: '700' }}> Step 1:</span> In the app
                                                    ZaloPay, select the phone top-up icon
                                                </li>
                                                <li>
                                                    <span style={{ fontWeight: '700' }}> Step 2:</span> Perform the
                                                    tasks in the program to receive gifts
                                                </li>
                                                <li>
                                                    <span style={{ fontWeight: '700' }}> Step 3:</span> Redeem golden ticket
                                                    Win a chance to win half a billion in cash prizes
                                                </li>
                                            </ul> */}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Row className={cx('banner_footer')}>
                                            <Button
                                                className={cx('btn_top_up')}
                                                // loading={isLoading}
                                                onClick={() => {
                                                    handelShowRefillNowModal();
                                                    setAmount(offer.from);
                                                }}
                                            >
                                                Buy now
                                            </Button>
                                        </Row>
                                    </Row>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <Row justify="center" align="middle" className={cx('card_no_exist')}>
                            Recharge card does not exist
                        </Row>
                    )}
                </>
            )}{' '}
            {isShowRefillNowModal && (
                <Modal
                    centered
                    visible={isShowRefillNowModal}
                    onCancel={onRejectRefillNow}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={480}
                >
                    <div style={{ padding: '30px 10px 0px 10px' }}>
                        <RefillNowModal
                            onRejectRefillNow={onRejectRefillNow}
                            onAgreeRefillNow={onAgreeRefillNow}
                            text="Are you sure you want to deposit money?"
                        />
                    </div>
                </Modal>
            )}
            {isShowCanNotShare && (
                <Modal
                    centered
                    visible={isShowCanNotShare}
                    onCancel={() => setIsShowCanNotShare(false)}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={500}
                >
                    <div style={{ padding: '20px 20px' }}>
                        <FormCanNot
                            onAgree={() => setIsShowCanNotShare(false)}
                            text="Buy now to become a collaborator and enable sharing feature!"
                            textAlignStart={false}
                            title="Notification"
                            btnBottom={true}
                        />
                    </div>
                </Modal>
            )}
            {isShowShare && (
                <Modal
                    centered
                    visible={isShowShare}
                    onCancel={() => setIsShowShare(false)}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={500}
                >
                    <div style={{ padding: '20px 20px' }}>
                        <FormShare
                            onAgree={handleAgreeShare}
                            onReject={handleRejectShare}
                            title={titleShare}
                            content={contentShare}
                        />
                    </div>
                </Modal>
            )}
            {isShowRequireLogin && (
                <Modal
                    centered
                    visible={isShowRequireLogin}
                    onCancel={() => setIsShowRequireLogin(false)}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={500}
                >
                    <div style={{ padding: '20px 20px' }}>
                        <CancelModal
                            onAgreeCancel={onAgreeLogin}
                            onRejectCancel={onRejectLogin}
                            text="Do you want to log in to continue?"
                        />
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default TopUpDetail;
